// import React, { useContext, useEffect, useState } from "react";
// import Box from "../../../setupPage/SharedComponents/Box";
// import SetupTittle from "../../../setupPage/SharedComponents/SetupTittle";
// import SetupContainer from "../../../setupPage/SharedComponents/SetupContainer";
// import GetLocalStorageUserId from "../../../sharedComponents/GetLocalStorageuserId";
// import axios from "axios";
// import Swal from "sweetalert2";
// import SetupInput from "../../../setupPage/SharedComponents/SetupInput";
// import SubmitBtn from "../../../setupPage/SharedComponents/SubmitBtn";
// import HistoryTable from "../../../setupPage/SharedComponents/HistoryTable";
// import SetupAutoComplete from "../../../setupPage/SharedComponents/SetupAutoComplete";
// import SetupTextArea from "../../../setupPage/SharedComponents/SetupTextArea";
// import { contextProvider } from "../../../setupPage/SetupPagesContextApi/SetupPagesContextApi";
// import { toast } from "react-toastify";
// import "./cashPayment.css"
// const CashPayment = () => {
//   const backendUrl = process.env.REACT_APP_API_URL;
//   const [fetchedData, setFetchedData] = useState([]);
//   const [refetch, setRefetch] = useState(false);
//   useEffect(() => {
//     axios
//       .get(`${backendUrl}Payment/GetAllPayments`)
//       .then((res) => setFetchedData(res.data))
//       .catch((err) => console.log(err.message));
//   }, [backendUrl, refetch]);

//   // input fields handle.
//   const initialValue = {
//     id: 1,
//     paymentMethodId: "",
//     paymentMethodName: "",
//     parcelOderNo: "",
//     orderAmount: "",
//     description: "",
//     paymentDate: "",
//     paymentInvoiceNo: "",
//     recordSerialNo: "", //
//     parcelNoWithRecordSerialNo: "",
//     creatorId: GetLocalStorageUserId(),
//     creationDate: new Date(),
//     modifierId: GetLocalStorageUserId(),
//     modificationDate: new Date(),
//   };

//   const [formData, setFormData] = useState(initialValue);
//   const [willUpdate, setWillUpdate] = useState(false);

//   console.log(formData,"this si sformdataaaaaaaaaaaaaaaaaaaaa.")
//   const update = (data) => {
//     setFormData({ ...formData, ...data });
//   };
//   const{handleDataReload}=useContext(contextProvider)
//   const formHandle = (e) => {
//     e.preventDefault();
//     formData.issueDate = new Date(formData.issueDate);
//     console.log(formData,"this si innnnnnnnnnnnnn.")
//     if (!willUpdate) {
//       axios
//         .post(`${backendUrl}Payment/CreatePayment`, { ...formData })

//         .then((res) => {
//           if(res.status===200) toast.error("Payment Already Completed For This Parcel Number.");
//           if (res.status === 201) {
//             Swal.fire({
//               title: `Cash Payment Created Successfully`,
//               icon: "success",
//             });
//             setRefetch((prev) => !prev);
//             setFormData(initialValue);
//             setWillUpdate(false);
//             handleDataReload()
//           }
//         })
//         .catch((err) => console.log(err));
//     }

//     if (willUpdate) {
//       console.log(formData);
//       axios
//         .put(`${backendUrl}Payment/CreatePayment/${formData.id}`, {
//           ...formData,
//         })

//         .then((res) => {
//           console.log(res,);
//           if (res.status === 204) {
//             Swal.fire({
//               title: `Additional Cost Updated Successfully`,
//               icon: "success",
//             });
//             setRefetch((prev) => !prev);
//             setFormData(initialValue);
//             setWillUpdate(false);
//             handleDataReload()
//           }
//         })
//         .catch((err) => console.log(err.message));
//     }
//   };

//   return (
//     <div>
//       <Box top>
//         <SetupTittle text="Payment" />
//         <SetupContainer>
//           <form className="" onSubmit={formHandle}>
//             <div className="grid lg:grid-cols-2 gap-y-4 grid-cols-1 lg:gap-y-[35px] lg:gap-x-[125px]">
//               <SetupInput
//                 type="date"
//                 placeHolder="Payment Date"
//                 name="IssueDate"
//                 allTimeValue={formData.paymentDate}
//                 valueUpdate={(e) => update({ paymentDate: e.target.value })}
//               />
//               <SetupAutoComplete
//                 dataOf="GetAllAdminParcel"
//                 valueUpdate={(_, value) => {
//                   console.log(value, "this si valieee");
//                   if (value?.parcelNo)
//                     axios
//                       .get(
//                         `${backendUrl}ParcelDetails/GetParcelDetailsByParcelNo/${value?.parcelNo}`
//                       )
//                       .then((res) => {
//                         console.log(
//                           res.data,

//                           "this is responsssssssssssse."
//                         );
//                         update({
//                           parcelOderNo: parseInt(value?.parcelNo),
//                           description: res.data?.description,
//                           orderAmount: res.data?.orderAmount,
//                           paymentMethodId: res.data?.paymentTypeMethodId,
//                           paymentMethodName:
//                             res.data?.paymentMethodName || "Not Available",
//                           parcelNoWithRecordSerialNo:
//                             value?.recordSerialNoWithParcelNo,
//                           recordSerialNo: value?.recordSerialNo||"",
//                           paymentInvoiceNo: "",
//                         });
//                       })
//                       .catch((err) => console.log(err));
//                   else
//                     update({
//                       parcelOderNo: "",
//                       description: "",
//                       orderAmount: "",
//                       paymentMethodId: "",
//                       paymentMethodName: "",
//                     });
//                 }}
//                 queryField="parcelNo"
//                 allTimeValue={parseInt(formData.parcelOderNo)}
//                 placeHolder="Parcel Number"
//               />
//               {/* <SetupAutoComplete
//                 dataOf="paymentMethod"
//                 valueUpdate={(_, value) => {
//                   console.log(value)
//                   update({ paymentMethodId:value?.id,paymentMethodName:value?.name })
//                 }}
//                 allTimeValue={formData.paymentMethodId}
//                 placeHolder="payment Method"
//               /> */}

//               <SetupInput
//                 disabled
//                 name="paymentMethod"
//                 type="text"
//                 placeHolder="payment Method"
//                 allTimeValue={formData.paymentMethodName}
//                 // valueUpdate={(e) =>
//                 //   update({ orderAmount: parseInt(e.target.value) })
//                 // }
//               />

//               <SetupInput
//                 disabled
//                 name="orderAmount"
//                 type="number"
//                 placeHolder="order Amount"
//                 allTimeValue={formData.orderAmount}
//                 valueUpdate={(e) =>
//                   update({ orderAmount: parseInt(e.target.value) })
//                 }
//               />

//               <SetupTextArea
//                 placeHolder="description"
//                 name="description"
//                 allTimeValue={formData.description}
//                 valueUpdate={(e) => update({ description: e.target.value })}
//               />
//               {formData?.paymentMethodName !== "Cash" && (
//                 <SetupInput
//                   name="paymentInvoiceNo"
//                   type="text"
//                   placeHolder="payment Invoice Number"
//                   allTimeValue={formData.paymentInvoiceNo}
//                   valueUpdate={(e) =>
//                     update({ paymentInvoiceNo: e.target.value })
//                   }
//                 />
//               )}
//             </div>
//             <SubmitBtn text={willUpdate ? "Update" : "Save"} />
//             <SubmitBtn
//               onClick={() => {
//                 setWillUpdate(false);
//                 update(initialValue);
//               }}
//               styleClass={!willUpdate && "hidden"}
//               text="Cancel"
//             />
//           </form>
//         </SetupContainer>
//       </Box>
//       <Box>
//         <SetupTittle text="History" />
//         <SetupContainer>
//           <div className="flex justify-end mb-4"></div>
//           <HistoryTable
//             // editCallBack={(data) => {
//             //   update(data);
//             //   setWillUpdate(true);
//             // }}
//             notEditAble
//             fetchedData={fetchedData}
//             headers={[
//               "payment Date",
//               "parcel order number",
//               // "record Serial Number",
//               // "payment Invoice No",
//               "order Amount",
//               "description",
//               "payment Method Name",
//             ]}
//             row={[
//               "paymentDate",
//               "parcelNoWithRecordSerialNo",
//               // "recordSerialNo",
//               // "",
//               "orderAmount",
//               "description",
//               "paymentMethodName",
//             ]}
//           />
//         </SetupContainer>
//       </Box>
//     </div>
//   );
// };

// export default CashPayment;

import React, { useContext, useEffect, useState } from "react";
import Box from "../../../setupPage/SharedComponents/Box";
import SetupTittle from "../../../setupPage/SharedComponents/SetupTittle";
import SetupContainer from "../../../setupPage/SharedComponents/SetupContainer";
import GetLocalStorageUserId from "../../../sharedComponents/GetLocalStorageuserId";
import axios from "axios";
import Swal from "sweetalert2";
import SetupInput from "../../../setupPage/SharedComponents/SetupInput";
import SubmitBtn from "../../../setupPage/SharedComponents/SubmitBtn";
import HistoryTable from "../../../setupPage/SharedComponents/HistoryTable";
import SetupAutoComplete from "../../../setupPage/SharedComponents/SetupAutoComplete";
import SetupTextArea from "../../../setupPage/SharedComponents/SetupTextArea";
import { contextProvider } from "../../../setupPage/SetupPagesContextApi/SetupPagesContextApi";
import { toast } from "react-toastify";
import "./cashPayment.css";
import { MenuItem, TextField } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import SetupDropDown from "../../../setupPage/SharedComponents/SetupDropdown";

const CashPayment = () => {
  const backendUrl = process.env.REACT_APP_API_URL;
  const [fetchedData, setFetchedData] = useState([]);
  const [refetch, setRefetch] = useState(false);
  const [paymentStatusOptions, setPaymentStatusOptions] = useState([]);
  const [loadingStatusOptions, setLoadingStatusOptions] = useState(false);

  // Fetch payment data
  useEffect(() => {
    axios
      .get(`${backendUrl}Payment/GetAllPayments`)
      .then((res) => setFetchedData(res.data))
      .catch((err) => {
        console.log(err.message);
        toast.error("Failed to load payment history");
      });
  }, [backendUrl, refetch]);

  // Initial form values
  const initialValue = {
    id: 1,
    paymentMethodId: "",
    paymentMethodName: "",
    parcelOderNo: "",
    orderAmount: "",
    description: "",
    paymentDate: "",
    paymentInvoiceNo: "",
    recordSerialNo: "",
    parcelNoWithRecordSerialNo: "",
    PaymentStatusId: 0,
    creatorId: GetLocalStorageUserId(),
    creationDate: new Date(),
    modifierId: GetLocalStorageUserId(),
    modificationDate: new Date(),
    currencyTypeId: 0,
    stripePaymentIntentId: "",
    stripeChargeId: "",
    cardLast4: "",
    cardBrand: "",
    stripePaymentMethod: "",
  };

  const [formData, setFormData] = useState(initialValue);
  const [willUpdate, setWillUpdate] = useState(false);

  const update = (data) => {
    setFormData({ ...formData, ...data });
  };

  const { handleDataReload } = useContext(contextProvider);

  const formHandle = (e) => {
    e.preventDefault();
    formData.paymentDate = new Date(formData.paymentDate);

    if (!willUpdate) {
      axios
        .post(`${backendUrl}Payment/CreatePayment`, { ...formData })
        .then((res) => {
          if (res.status === 200) {
            toast.error("Payment Already Completed For This Parcel Number.");
          }
          if (res.status === 201) {
            Swal.fire({
              title: `Cash Payment Created Successfully`,
              icon: "success",
            });
            setRefetch((prev) => !prev);
            setFormData(initialValue);
            setWillUpdate(false);
            handleDataReload();
          }
        })
        .catch((err) => {
          console.log(err);
          toast.error("Failed to create payment");
        });
    } else {
      axios
        .put(`${backendUrl}Payment/UpdatePayment/${formData.id}`, {
          ...formData,
          PaymentStatusId: parseInt(formData.PaymentStatusId),
        })
        // .put(`${backendUrl}Payment/UpdatePayment`, {
        //   ...formData,
        // })
        .then((res) => {
          if (res.status === 204) {
            Swal.fire({
              title: `Payment Updated Successfully`,
              icon: "success",
            });
            setRefetch((prev) => !prev);
            setFormData(initialValue);
            setWillUpdate(false);
            handleDataReload();
          }
        })
        .catch((err) => {
          console.log(err.message);
          toast.error("Failed to update payment");
        });
    }
  };

  useEffect(() => {
    const today = new Date();
    const formattedDate = today.toISOString().split("T")[0]; // YYYY-MM-DD format
    setFormData((prev) => ({
      ...prev,
      paymentDate: formattedDate,
    }));
  }, []);

  return (
    <div>
      <Box top>
        <SetupTittle text="Payment" />
        <SetupContainer>
          <form onSubmit={formHandle}>
            <div className="grid lg:grid-cols-2 gap-y-4 grid-cols-1 lg:gap-y-[35px] lg:gap-x-[125px]">
              <SetupInput
                type="date"
                placeHolder="Payment Date"
                name="paymentDate"
                allTimeValue={formData.paymentDate}
                valueUpdate={(e) => update({ paymentDate: e.target.value })}
                required
              />

              {/* <SetupAutoComplete
                dataOf="GetAllAdminParcel"
                valueUpdate={(_, value) => {
                  if (value?.parcelNo) {
                    axios
                      .get(
                        `${backendUrl}ParcelDetails/GetParcelDetailsByParcelNo/${value?.parcelNo}`
                      )
                      .then((res) => {
                        const defaultStatus = paymentStatusOptions.find(
                          (status) => status.isDefault
                        );
                        update({

                          parcelOderNo: parseInt(value?.parcelNo),
                          description: res.data?.description,
                          orderAmount: res.data?.orderAmount,
                          paymentMethodId: res.data?.paymentTypeMethodId,
                          paymentMethodName:
                            res.data?.paymentMethodName || "Not Available",
                          parcelNoWithRecordSerialNo:
                            value?.recordSerialNoWithParcelNo,
                          recordSerialNo: value?.recordSerialNo || "",
                          paymentInvoiceNo: "",
                          paymentStatus: defaultStatus?.id || 0,
                        });

                        if (defaultStatus?.Id==1 ||defaultStatus?.Id==null) {
                          setWillUpdate(true);
                        }
                      }
                    )
                      .catch((err) => console.log(err));
                  } else {
                    update({
                      parcelOderNo: "",
                      description: "",
                      orderAmount: "",
                      paymentMethodId: "",
                      paymentMethodName: "",
                      PaymentStatusId: null,
                    });
                  }
                }}
                queryField="parcelNo"
                allTimeValue={parseInt(formData.parcelOderNo)}
                placeHolder="Parcel Number"
                required
              /> */}
              <SetupAutoComplete
                dataOf="GetAllAdminParcel"
                valueUpdate={(_, value) => {
                  if (value?.parcelNo) {
                    axios
                      .get(
                        `${backendUrl}ParcelDetails/GetParcelDetailsByParcelNo/${value?.parcelNo}`,
                      )
                      .then((res) => {
                        update({
                          id: res.data?.paymentId || 0, // Set the paymentId from API response
                          parcelOderNo: parseInt(value?.parcelNo),
                          description: res.data?.description,
                          orderAmount: res.data?.orderAmount,
                          paymentMethodId: res.data?.paymentTypeMethodId,
                          paymentMethodName:
                            res.data?.paymentMethodName || "Not Available",
                          parcelNoWithRecordSerialNo:
                            value?.recordSerialNoWithParcelNo,
                          recordSerialNo: value?.recordSerialNo || "",
                          paymentInvoiceNo: "",
                          PaymentStatusId: res.data?.paymentStatusId || 0,
                        });

                        // Set willUpdate based on whether payment exists

                        if (
                          res.data?.paymentStatusId == 1 ||
                          res.data?.paymentStatusId == null ||
                          res.data?.paymentStatusId == 3
                        ) {
                          setWillUpdate(true);
                        }
                      })
                      .catch((err) => console.log(err));
                  } else {
                    update({
                      id: 0, // Reset paymentId
                      parcelOderNo: "",
                      description: "",
                      orderAmount: "",
                      paymentMethodId: "",
                      paymentMethodName: "",
                      PaymentStatusId: 0,
                    });
                    setWillUpdate(false);
                  }
                }}
                queryField="parcelNo"
                allTimeValue={parseInt(formData.parcelOderNo)}
                placeHolder="Parcel Number"
                required
              />
              <SetupInput
                disabled
                name="paymentMethod"
                type="text"
                placeHolder="Payment Method"
                allTimeValue={formData.paymentMethodName}
              />

              <SetupInput
                disabled
                name="orderAmount"
                type="number"
                placeHolder="Order Amount"
                allTimeValue={formData.orderAmount}
              />

              <SetupDropDown
                dataOf={"currency"}
                allTimeValue={formData.currencyTypeId}
                valueUpdate={(e) => update({ currencyTypeId: e.target?.value })}
                placeHolder="Currency Type"
                name="id"
              ></SetupDropDown>

              <SetupTextArea
                placeHolder="Description"
                name="description"
                allTimeValue={formData.description}
                valueUpdate={(e) => update({ description: e.target.value })}
              />

              {/* Payment Status Dropdown */}
              <SetupDropDown
                dataOf={"PaymentStatus"} // Make sure this matches your API endpoint
                allTimeValue={formData.PaymentStatusId}
                valueUpdate={(e) =>
                  update({ PaymentStatusId: e.target?.value })
                }
                placeHolder="Payment Status"
                name="id"
              />

              {formData?.paymentMethodName !== "Cash" && (
                <SetupInput
                  name="paymentInvoiceNo"
                  type="text"
                  placeHolder="Payment Invoice Number"
                  allTimeValue={formData.paymentInvoiceNo}
                  valueUpdate={(e) =>
                    update({ paymentInvoiceNo: e.target.value })
                  }
                />
              )}
            </div>
            <SubmitBtn text={willUpdate ? "Update" : "Save"} />
            <SubmitBtn
              onClick={() => {
                setWillUpdate(false);
                update(initialValue);
              }}
              styleClass={!willUpdate && "hidden"}
              text="Cancel"
            />
          </form>
        </SetupContainer>
      </Box>
      <Box>
        <SetupTittle text="History" />
        <SetupContainer>
          <HistoryTable
            editCallBack={async (historyData) => {
              try {
                const parcelNumber =
                  historyData.parcelOderNo ||
                  (historyData.parcelNoWithRecordSerialNo
                    ? historyData.parcelNoWithRecordSerialNo.split("~")[0]
                    : null);

                if (!parcelNumber) {
                  toast.error("Could not determine parcel number");
                  return;
                }

                // Fetch complete parcel details
                const parcelResponse = await axios.get(
                  `${backendUrl}ParcelDetails/GetParcelDetailsByParcelNo/${parcelNumber}`,
                );
                const parcelData = parcelResponse.data;

                // Transform all data into form format
                const formReadyData = {
                  id: historyData.id || 0,
                  paymentMethodId:
                    parcelData.paymentTypeMethodId ||
                    historyData.paymentMethodId ||
                    "",
                  paymentMethodName:
                    parcelData.paymentMethodName ||
                    historyData.paymentMethodName ||
                    "",
                  parcelOderNo: parcelNumber,
                  orderAmount:
                    parcelData.orderAmount || historyData.orderAmount || 0,
                  description:
                    historyData.description || parcelData.description || "",
                  paymentDate:
                    historyData.paymentDate?.split("T")[0] ||
                    new Date().toISOString().split("T")[0],
                  paymentInvoiceNo: historyData.paymentInvoiceNo || "",
                  recordSerialNo:
                    parcelData.recordSerialNo ||
                    historyData.recordSerialNo ||
                    "",
                  parcelNoWithRecordSerialNo:
                    parcelData.recordSerialNoWithParcelNo ||
                    historyData.parcelNoWithRecordSerialNo ||
                    "",
                  PaymentStatusId:
                    parcelData.paymentStatusId ||
                    historyData.paymentStatusId ||
                    0,
                  creatorId: historyData.creatorId || GetLocalStorageUserId(),
                  creationDate: historyData.creationDate || new Date(),
                  modifierId: historyData.modifierId || GetLocalStorageUserId(),
                  modificationDate: historyData.modificationDate || new Date(),
                  currencyTypeId:
                    parcelData.currencyTypeId ||
                    historyData.currencyTypeId ||
                    0,
                };

                console.log("Form ready data:", formReadyData);
                update(formReadyData);
                setWillUpdate(true);
              } catch (error) {
                console.error("Error loading parcel details:", error);
                toast.error("Failed to load complete parcel data");
              }
            }}
            fetchedData={fetchedData}
            headers={[
              "Payment Date",
              "Parcel Order Number",
              "Order Amount",
              "Currency Type",
              "Description",
              "Payment Method",
              "Payment Status",
              "Action",
            ]}
            row={[
              "paymentDate",
              "parcelNoWithRecordSerialNo",
              "orderAmount",
              "currencyType",
              "description",
              "paymentMethodName",
              "statusName",
            ]}
            extraFields={["paymentStatusId", "currencyTypeId"]} // Add this line to include extra fields
          />
        </SetupContainer>
      </Box>
    </div>
  );
};

export default CashPayment;
